import React from 'react'
import { Link } from 'gatsby'
import { Html } from 'generated/types/gatsby'
import './PrevAndNext.scss'

interface PrevAndNextProps {
  readonly prev: Html
  readonly next: Html
  readonly scrollTop: number
}
const PrevAndNext = ({ prev, next, scrollTop }: PrevAndNextProps) => {
  if (!prev && !next) {
    return null
  }

  return (
    <div className="la-pagination">
      {prev && (
        <Link
          className="la-pagination-prev-btn"
          to={prev.frontmatter.slug}
          state={{ scrollTop: scrollTop }}
        >
          {prev.frontmatter.title}
        </Link>
      )}
      {next && (
        <Link
          className="la-pagination-next-btn"
          to={next.frontmatter.slug}
          state={{ scrollTop: scrollTop }}
        >
          {next.frontmatter.title}
        </Link>
      )}
    </div>
  )
}

export default PrevAndNext
